import React, { useEffect } from "react";
import Routes from "./pages/routes";
import GlobalCSS from "./styles/global";
import "react-indiana-drag-scroll/dist/style.css";
import { connectSockets } from "./services/sockets";
import { QueryClientProvider } from '@tanstack/react-query'
import { DndProvider } from 'react-dnd'
import { HTML5Backend } from 'react-dnd-html5-backend'
import { queryClient } from "./services/react-query";
import { useUser } from "./store/global/useUser";
import { setSentryUser, clearSentryUser } from "./config/sentry";

import { pdfjs } from 'react-pdf';
import { MuiBrandTheme } from "./providers/muiTheme";


pdfjs.GlobalWorkerOptions.workerSrc = new URL(
  'pdfjs-dist/build/pdf.worker.min.mjs',
  import.meta.url,
).toString();



function App() {
  connectSockets();

  // Para habilitar tracking de usuário no Sentry, descomente o bloco abaixo
  // e os imports acima (useUser e setSentryUser/clearSentryUser)
  useEffect(() => {
    const unsubscribe = useUser.subscribe((state) => {
      const user = state?.data?.user;
      if (user) {
        setSentryUser(user);
      } else {
        clearSentryUser();
      }
    });
    const currentUser = useUser.getState()?.data?.user;
    if (currentUser) setSentryUser(currentUser);
    return () => unsubscribe();
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      <GlobalCSS />
      <MuiBrandTheme>
        <DndProvider backend={HTML5Backend}>
          <Routes />
        </DndProvider>
      </MuiBrandTheme>
    </QueryClientProvider>
  );
}

export default App;
